export const PDFLink = 'pdflink';
